import {Dispatch} from 'react';

class Subject<SubjectItem> {
  private _data: SubjectItem;
  private _listeners: Record<string, Dispatch<SubjectItem>>;

  constructor(initialValue: SubjectItem) {
    this._data = initialValue;
    this._listeners = {};
  }

  get data() {
    return this._data;
  }

  set data(value: SubjectItem) {
    this._data = value;

    Object.values(this._listeners).forEach((callback) => callback(value));
  }

  subscribe = (callback: Dispatch<SubjectItem>) => {
    const id = Math.floor(Math.random() * 1e9).toString();
    this._listeners[id] = callback;

    return id;
  };

  unsubscribe = (id: string) => {
    delete this._listeners[id];
  };
}

export default Subject;
